module.exports = __webpack_public_path__ + "img/Food-Card-1.018c5fa3.png";